module.exports = __webpack_public_path__ + "img/header-image-2.b67d1d66.png";